import debug from 'debug';
import slugify from 'slugify';
// import _ from 'lodash';
import { createSelector } from 'reselect';
import mapValues from 'lodash.mapvalues';
import groupBy from 'lodash.groupby';

import { TEAMS_KEY } from '../actions/teams.types';

const log = debug('huddle:store:selectors:teams');

export const filterTeams = teams => {
  const newTeams = {};
  Object.entries(teams).forEach(entry => {
    const [key, value] = entry;
    const forbidden_team_ids = ['-1', '0'];
    forbidden_team_ids.includes(key) ? '' : (newTeams[key] = value);
  });
  return newTeams;
};

export const selectTeams = state => state[TEAMS_KEY];

export const selectTeamsForDropdown = createSelector(
  selectTeams,
  ({ loading, error, ...teams }) => Object.keys(teams).map(id => ({
    key: teams[id].abbr,
    value: Number(id),
    text: `${teams[id].city} ${teams[id].name}`,
  })),
);

export const selectTeamsForDropdownAlpha = createSelector(
  selectTeamsForDropdown,
  teams => teams.sort((teamA, teamB) => {
    if (teamA.text > teamB.text) return 1;
    if (teamA.text < teamB.text) return -1;
    return 0;
  }),
);

export const selectTeamsHierarchy = state => {
  const { loading, error, ...teams } = selectTeams(state);
  const newTeams = filterTeams(teams);
  return mapValues(groupBy(newTeams, 'conference'), confTeams => (
    groupBy(confTeams, 'division')
  ));
};

export const selectTeamLogoAndColor = (state, id) => {
  const { loading, error, ...teams } = selectTeams(state);
  return ({
    logo: teams[id].logo.small,
    color: teams[id].color,
  });
};

// export const selectTeamNamePath = (state, id) => {
//   const { loading, error, ...teams } = selectTeams(state);
//   return ({
//     path: slugify(`${teams[id].city} ${teams[id].name}`),
//   });
// };

export const selectTeamNamePath = createSelector(
  selectTeams,
  ({ loading, error, ...teams }) => {
    const teamNames = {};
    Object.keys(teams).forEach(id => teamNames[id] = slugify(`${teams[id].city} ${teams[id].name}`, { lower: true }));
    return teamNames;
  },
);



// WEBPACK FOOTER //
// ./src/store/reducers/teams.selectors.js